import { Box, IconButton, Stack } from '@mui/joy';
import { PhoneDisconnect, PhoneCall } from '@phosphor-icons/react';

export default function ButtonsIncoming({ endCall, acceptCall }) {
    return (
        <Stack direction="row" spacing={8} alignItems="center" sx={{ zIndex: 10 }}>
            <IconButton
                onClick={endCall}
                sx={{
                    width: 68, height: 68,
                    borderRadius: '50%',
                    bgcolor: '#FF3B30',
                    color: '#fff',
                    boxShadow: 'none',
                    transition: 'background-color 0.15s ease, transform 0.1s ease',
                    '&:hover': { bgcolor: '#FF5247', boxShadow: 'none' },
                    '&:active': { transform: 'scale(0.95)' },
                    '& svg': { color: '#fff' },
                }}
            >
                <PhoneDisconnect size={30} weight="fill" />
            </IconButton>

            <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {[1, 2, 3].map((ring) => (
                    <Box key={ring} sx={{
                        position: 'absolute',
                        width: 68, height: 68,
                        borderRadius: '50%',
                        border: '2px solid rgba(52, 199, 89, 0.5)',
                        animation: 'ripple 2s ease-out infinite',
                        animationDelay: `${ring * 0.5}s`,
                        '@keyframes ripple': {
                            '0%': { transform: 'scale(1)', opacity: 0.7 },
                            '100%': { transform: 'scale(2.2)', opacity: 0 },
                        },
                    }} />
                ))}
                <IconButton
                    onClick={acceptCall}
                    sx={{
                        width: 68, height: 68,
                        borderRadius: '50%',
                        bgcolor: '#34C759',
                        color: '#fff',
                        boxShadow: 'none',
                        zIndex: 1,
                        transition: 'background-color 0.15s ease, transform 0.1s ease',
                        '&:hover': { bgcolor: '#3DDC6A', boxShadow: 'none' },
                        '&:active': { transform: 'scale(0.95)' },
                        '& svg': { color: '#fff' },
                    }}
                >
                    <PhoneCall size={30} weight="fill" />
                </IconButton>
            </Box>
        </Stack>
    );
}
